import { render, staticRenderFns } from "./StudentSurveyModal.vue?vue&type=template&id=16a944ba&scoped=true"
import script from "./StudentSurveyModal.vue?vue&type=script&lang=js"
export * from "./StudentSurveyModal.vue?vue&type=script&lang=js"
import style0 from "./StudentSurveyModal.vue?vue&type=style&index=0&id=16a944ba&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16a944ba",
  null
  
)

export default component.exports